// src/theme.ts
import { createTheme } from '@mui/material/styles';

// Roche color system
const colors = {
  // Blues
  rocheBlue: '#0B41CD',
  darkBlue: '#022366',
  lightBlue: '#1482FA',
  extraLightBlue: '#BDE3FF',
  
  // Neutrals and Grays
  neutral3: '#FAF0ED', // From the image, appears to be a very light beige
  neutral4: '#FAF6F5', // Lighter than neutral3
  grey4: '#D9D9D9',    // Medium gray
  grey5: '#E6E6E6',    // Light gray
  
  // Black and White
  black: '#000000',
  white: '#FFFFFF',
};

// Create the theme
const theme = createTheme({
  palette: {
    primary: {
      main: colors.rocheBlue,
      dark: colors.darkBlue,
      light: colors.lightBlue,
    },
    secondary: {
      main: colors.grey4,
      light: colors.grey5,
    },
    background: {
      default: colors.white,
      paper: colors.neutral4,
    },
    text: {
      primary: colors.black,
      secondary: colors.darkBlue,
    },
  },
  typography: {
    fontFamily: "'Roche Sans', Arial, sans-serif",
    // Display (A head)
    h1: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 300, // Light
      fontSize: '2.5rem',
    },
    // Headline (B head)
    h2: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 300, // Light
      fontSize: '2rem',
    },
    // Subheading (C head)
    h3: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 400, // Regular
      fontSize: '1.5rem',
    },
    // Additional headings
    h4: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 500, // Medium
      fontSize: '1.25rem',
    },
    h5: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 500, // Medium
      fontSize: '1.1rem',
    },
    h6: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 700, // Bold
      fontSize: '1rem',
    },
    // Body copy
    body1: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 300, // Light
      fontSize: '1rem',
    },
    body2: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 400, // Regular
      fontSize: '0.875rem',
    },
    // Captions
    caption: {
      fontFamily: "'Roche Sans', Arial, sans-serif",
      fontWeight: 300, // Light
      fontSize: '0.75rem',
    },
    // Condensed variants and other special cases can be handled with custom classes
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Global styles
        body: {
          backgroundColor: colors.white,
          color: colors.black,
        },
        // Pull quotes style
        blockquote: {
          fontFamily: "'Roche Serif', Georgia, serif",
          fontWeight: 300, // Light
          fontStyle: 'italic',
          borderLeft: `4px solid ${colors.lightBlue}`,
          paddingLeft: '1rem',
          margin: '1rem 0',
        },
        // Link styles
        a: {
          color: colors.rocheBlue,
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    // Customize specific MUI components
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Roche Sans', Arial, sans-serif",
          fontWeight: 400, // Regular
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;